<script setup lang="ts">
import type { Product } from 'types/models/product'
import type { AddToCartSources } from '~/types/gtm'

interface Props {
  products: Product[]
  pageSource?: AddToCartSources
}

withDefaults(defineProps<Props>(), {
  pageSource: 'productPageUpsell',
})

function scrollToTop() {
  const scrollView = document.querySelector('#scroll-view')
  scrollView?.scrollTo({ behavior: 'smooth', top: 0 })
}
</script>

<template>
  <aside>
    <ProductAdaptiveCarousel
      :show-multiple-items="true"
      :show-arrow-background="true"
      :cards-count="products.length"
      :show-track="false"
    >
      <li
        v-for="item in products"
        :key="`related-${item.sku}`"
        class="card"
        @click="scrollToTop"
      >
        <ProductCard
          class="product"
          :product="item"
          :is-related="true"
          :has-quick-shop="true"
          data-test="related-product"
          :page-source="pageSource"
        />
      </li>
    </ProductAdaptiveCarousel>
  </aside>
</template>

<style lang="scss" scoped>
@import 'assets/scss/rules/breakpoints';
h4 {
  width: 100%;
  font-weight: bold;
  font-size: 1.6rem;
  text-align: center;
  line-height: 1.8rem;
  margin-bottom: 2.5rem;
}
</style>
